import { render } from "./tipoproyecto.vue?vue&type=template&id=89ffde42"
import script from "./tipoproyecto.vue?vue&type=script&lang=js"
export * from "./tipoproyecto.vue?vue&type=script&lang=js"

import "./tipoproyecto.vue?vue&type=style&index=0&id=89ffde42&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__